import React from 'react'
import { UserAvatar } from 'modules/atoms/user-avatar'
import { EmployeeStatus } from 'modules/atoms/employee-status'

export const headers = (t: any) => {
  return [
    {
      key: 'name',
      title: t('signature.global.rows.name'),
      filterable: true,
      render: (_: any, user: any) => (
        <UserAvatar
          avatar={user?.avatar_url}
          name={`${user?.name} ${user?.lastname}`}
        />
      )
    },
    {
      key: 'enrollment_status',
      title: t('signature.global.rows.state'),
      visible: true,
      filterable: true,
      type: 'list',
      list: [
        {
          label: t('signature.admin.usersTemplate.table.filters.labels.pending'),
          value: "pending"
        },
        {
          label: t('signature.admin.usersTemplate.table.filters.labels.active'),
          value: "active"
        },
        {
          label: t('signature.admin.usersTemplate.table.filters.labels.inProgress'),
          value: "in_progress"
        }
      ],
      excludedOperators: [
        "null",
        "not_null"
      ],
      render: (status: string) => <EmployeeStatus status={status} />
    },
    {
      key: 'email',
      title: 'Email',
      filterable: true,
      type: 'string'
    },
    {
      key: 'area',
      title: t('signature.global.rows.area'),
      visible: true,
      filterable: true,
      render: (_: any, user: any) => <span>{user.area?.name}</span>
    },
    {
      key: 'position',
      title: t('signature.global.rows.position'),
      visible: true,
      filterable: true,
      render: (_: any, user: any) => <span>{user.position?.name}</span>
    }
  ]
}
